import { render, staticRenderFns } from "./ContextualAction.vue?vue&type=template&id=add67184"
import script from "./ContextualAction.vue?vue&type=script&lang=js"
export * from "./ContextualAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports